import React from 'react';
import { Square, Volume2 } from 'lucide-react';

export default function PracticeSession({ midiPlayer, pitchDetection, settings, streak, onStop }) {
  return (
    <div className="space-y-6">
      {/* Visual Feedback */}
      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
        <div className="text-center">
          <div className="mb-6">
            <div className="inline-block p-4 bg-purple-500/30 rounded-full">
              <Volume2 className="w-16 h-16 text-purple-200" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Listening...</h2>
          <p className="text-white/70">Sing along with the melody</p>
        </div>

        {/* Pitch Meter */}
        <div className="mt-8">
          <div className="h-32 bg-white/5 rounded-xl flex items-center justify-center">
            <div className="text-center">
              <p className="text-white/50 text-sm mb-2">Current Note</p>
              <p className="text-4xl font-bold text-white">
                {pitchDetection?.currentNote || '---'}
              </p>
              <p className="text-white/70 text-sm mt-2">
                {pitchDetection?.currentFrequency?.toFixed(1) || '---'} Hz
              </p>
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mt-6">
          <div className="flex justify-between text-white/70 text-sm mb-2">
            <span>{Math.floor(midiPlayer?.currentTime || 0)}s</span>
            <span>{Math.floor(midiPlayer?.duration || 0)}s</span>
          </div>
          <div className="h-2 bg-white/10 rounded-full overflow-hidden">
            <div
              className="h-full bg-purple-600 transition-all duration-300"
              style={{ width: `${((midiPlayer?.currentTime || 0) / (midiPlayer?.duration || 1)) * 100}%` }}
            />
          </div>
        </div>
      </div>

      {/* Controls */}
      <button
        onClick={onStop}
        className="w-full py-4 bg-red-600 hover:bg-red-700 text-white rounded-xl font-bold text-lg transition-colors flex items-center justify-center gap-2"
      >
        <Square className="w-6 h-6" />
        Stop Practice
      </button>
    </div>
  );
}